import { Flex } from '@indoqa/style-system';
import * as React from 'react';
import { withUIETheme } from '../uietheme/withUIETheme';
const ContentHeader = ({ children, uieTheme }) => {
    const style = {
        boxSizing: 'border-box',
        height: uieTheme.layout.topMenuHeight,
        paddingLeft: uieTheme.spacing.space4,
        backgroundColor: uieTheme.colors.bgContentHeader,
    };
    return (React.createElement(Flex, { fullWidth: true, style: style, alignItems: "center" }, children));
};
export default withUIETheme(ContentHeader);
//# sourceMappingURL=ContentHeader.js.map